module.exports = __webpack_public_path__ + "assets/images/64bfdcefe79bd40c1c90e9096fd76255.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/icons/angellist.svg
// module id = 722
// module chunks = 0